// Redux Actions Types
import { SET_USER_PROFILE } from './types';

export const setUserProfile = payload => ({
  type: SET_USER_PROFILE,
  payload
});
